document.addEventListener('DOMContentLoaded', function () {
    const descDiv = document.getElementById('washortdesc');
    const btn = document.getElementById('washortdescbtn');
    const paragraphs = descDiv.querySelectorAll('p');
    for (let i = 1; i < paragraphs.length; i++) {
      paragraphs[i].style.display = 'none';
    }
    btn?.addEventListener('click', function () {
      const isExpanded = paragraphs[1].style.display === 'block';
      if (isExpanded) {
        for (let i = 1; i < paragraphs.length; i++) {
          paragraphs[i].style.display = 'none';
        }
        btn.textContent = 'weiterlesen';
      } else {
        for (let i = 1; i < paragraphs.length; i++) {
          paragraphs[i].style.display = 'block';
        }
        btn.textContent = 'weniger lesen';
      }
    });
  });

/***************************/
/*
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
console.log(items)
items.forEach(item => {
item.addEventListener("mouseover", () => {
item.setAttribute("open", true);
item.querySelector("ul").addEventListener("mouseleave", () => {
item.removeAttribute("open");
});
item.addEventListener("mouseleave", () => {
item.removeAttribute("open");
});
});

});
*/
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");

items.forEach(item => {
  let timeoutId;

  item.addEventListener("mouseover", () => {
    clearTimeout(timeoutId);
    item.setAttribute("open", true);
  });

  item.addEventListener("mouseleave", () => {

    timeoutId = setTimeout(() => {
      item.removeAttribute("open");
    }, 200); 
  });

  item.querySelector("ul").addEventListener("mouseleave", () => {
    // Close the dropdown when leaving the ul
    timeoutId = setTimeout(() => {
      item.removeAttribute("open");
    }, 200);
  });

  item.querySelector("ul").addEventListener("mouseover", () => {
    clearTimeout(timeoutId); 
  });
});